module.exports = "/_next/static/images/bb29911dfc0f1e8f11a99ba3ec8b5d59-man-holding-device-2@0.5x.jpg.webp";